module.exports = __webpack_public_path__ + "img/logo.e6274b4e.png";